import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CategoryProfitRequest, CategoryResponse } from 'src/app/models/category.model';
import { ProductPriceListResponse } from 'src/app/models/price-list.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CategoryService } from 'src/app/services/category.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { PlaceService } from 'src/app/services/place.service';

@Component({
  selector: 'app-price-list-by-location',
  templateUrl: './price-list-by-location.component.html',
  styleUrls: ['./price-list-by-location.component.scss']
})
export class PriceListByLocationComponent implements OnInit {
  allPlaces: any[] = [];
  allPlacesColumn: any[] = [];
  placeSelectedId = -1;
  allCategories: any[] = [];
  categorySelectedId = -1;

  priceListLists: any[] = [];
  // priceListSelected: ProductPriceListResponse = null;
  // priceListSelectedId: number = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }

  allPriceList: any[] = [{ name: "CF", id: 1 }, { name: 'ELECTRICISTAS', id: 2 }];
  priceListSelectedId = -1;
  allCategoriesRows = [];
  categoriesRows: any[] = [];
  editFamily: { [key: string]: number } = {};
  profits: { [key: string]: number } = {};
  profitItem: { [key: string]: any } = {};
  pricesList: { [key: string]: any } = {};
  loading: { [key: string]: boolean } = {};

  constructor(private inventoryService: InventoryService,
    private placeService: PlaceService,
    private categoryService: CategoryService,
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.loadPlaces();
    this.loadCategories();
  }

  loadPlaces() {
    this.placeService.getPlaces().subscribe({
      next: (resp: ResponseObject) => {
        this.allPlaces = resp.data || [];
        this.allPlacesColumn = resp.data || [];
        // this.refreshPlacesPagination();
      },
      error: () => this.toastService.error('Error al obtener ubicaciones')
    });
  }

  loadCategories() {
    this.categoryService.getCategories().subscribe({
      next: (resp: ResponseObject) => {
        this.allCategories = resp.data || [];
        
      },
      error: () => this.toastService.error('Error al obtener ubicaciones')
    });
  }

  getPriceList() {
    this.inventoryService.getProductPricesList().subscribe({
      next: (response: ResponseObject) => {
        this.priceListLists = response.data;
        this.pagination.filter = this.priceListLists;
        this.pagination.total = this.priceListLists;
        this.resetPagination();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pueden obtener las listas de precios.", "Error")
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  changingPlace() {

  }

  changingCategory() {
    this.getProfitMarginGrouped(this.priceListSelectedId);
  }

  changingPriceList() {
    this.getProfitMarginGrouped(this.priceListSelectedId);
  }

  getProfitMarginGrouped(id: any) {
    if (id == -1) return;

    this.profits = {};
    this.editFamily = {};
    this.categoryService.getCategoriesProfitGrouped(id).subscribe({
      next: (response: ResponseObject) => {
        this.allCategoriesRows = response.data.categories ?? [];
        this.pricesList = response.data.priceLists ?? [];
        this.pricesList = this.pricesList.filter((p: any) => p.placeId );
        this.pricesList = this.pricesList.sort((a: any, b: any) => a.placeName.localeCompare(b.placeName));

        this.allCategoriesRows.forEach((element: any) => {
          element.profits.forEach((element2: any) => {
            this.profits[`${element.categoryId}_${element2.priceListId}`] = element2.profitPercentage;
            this.profitItem[`${element.categoryId}_${element2.priceListId}`] = element2;
          });
        });
        this.categoriesRows = [];
        this.resetFilter();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pueden obtener los margenes.", "Error")
      }
    });
  }

  resetFilter(){
    if (this.categorySelectedId > 0) {
      this.categoriesRows = this.allCategoriesRows.filter((c: any) => c.categoryId==this.categorySelectedId);
      return;
    }
    this.categoriesRows = this.allCategoriesRows;
  }

  editProfitFamily(itemId: any) {
    if (this.editFamily[itemId] != undefined) {
      return;
    }
    this.editFamily[itemId] = this.profits[itemId];
  }

  saveProfitOfSingleCategory(categoryId: any, priceListId: any, profit: number) {
    const itemId = `${categoryId}_${priceListId}`;
    if (this.loading[itemId]) {
      return;
    }
    this.loading[itemId] = true;
    var tempCategory = new CategoryProfitRequest(categoryId, profit, priceListId);
    this.saveProfit([tempCategory]);
  }

  saveProfit(categoryProfits: CategoryProfitRequest[]) {
    const item = categoryProfits[0];
    if (!item) return;

    const itemId = `${item.category}_${item.priceList}`;
    this.categoryService.addProfitToCategory(categoryProfits).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Datos del Margen almacenados correctamente.");
        categoryProfits.forEach((c) => {
          if (this.loading[itemId]) {
            delete this.loading[itemId];
            if (this.editFamily[itemId] != undefined) {
              this.profits[itemId] = this.editFamily[itemId];
              delete this.editFamily[itemId];
            }
          }
        });
        this.getProfitMarginGrouped(this.priceListSelectedId);
      },
      error: (error: any) => {
        this.toastService.error("Error en enviar datos.");
      }
    })
  }
}
